// extracted by css-extract-rspack-plugin
export default {"summaryMetricFacets":"qQDsjukYc8kc9MeD","summaryMetricFacet":"uSHjcJKaxiYNzi6c"};